import type {
  AdmissionStatus,
  AdmissionType,
  AssistiveDeviceType,
  CompanionType,
  DisabilityType,
  Nullable,
} from '@/types';
import type { Ref } from 'vue';
import type { Address } from '@/types/customer/address.types';

export interface Phone {
  number: string;
  extension: string;
}

/** propriétés communes pour une aide à la mobilité */
export type AssistiveDeviceBase = {
  id: string;
  fr: string;
  en: string;
};

/** Aide à la mobilité */
export interface AssistiveDevice extends AssistiveDeviceBase {
  isPrimary: boolean;
  type: AssistiveDeviceType;
}

/** Aides à la mobilité, plus des données pour le traitement interne côté Frontend */
export type AssistiveDeviceMapped = AssistiveDevice & {
  /** Identificateur unique originale, lorsque celui-ci a été renommé côté Frontend pour fins de traitements internes */
  idOriginal?: string;
};

export interface CustomerProfile {
  fullName: string;
  firstName: string;
  lastName: string;
  fileNumber: string;
  admission: Nullable<ProfileAdmission>;
  homeAddress: Address | null;
  homePhone: Phone | null;
  cellPhone: Phone | null;
  email: string;
  areAddressesRestricted: boolean;
  assistiveDevices: AssistiveDevice[];
  bookingCompanionsAllowed: boolean;
  otherEmailAddresses: string[];
  isLavalCustomer: boolean;
  isBookingAllowed: boolean;
  administrativeNote: string | null;
  disability: DisabilityType | null;
}

/** Propriétés simplifiées pour l'affichage de n'importe quel type d'admission */
export interface ProfileAdmission {
  type: AdmissionType;
  status: AdmissionStatus;
  description: string;
  expiration: Nullable<AdmissionExpiration>;
  startDateOrTime: string;
  endDateOrTime: string;
  companionType: CompanionType;
}

interface AdmissionExpiration {
  status: 'near' | 'expired' | null;
  date: string;
}

/** propriétés exposées du contrôleur de modification des infos utilisateurs */
export type ModifyCustomerInfoControllerExposed = {
  isSubmitting: Ref<boolean>;
};

/** Payload pour l'envoi des données de formulaire au backend */
export type CustomerFormDto = {
  homeAddressCivicNumber: string;
  homeAddressStreetDescription: string;
  homeAddressMunicipalityName: string;
  homeAddressPostalCode: string;
  homeAddressSuite: string | null;
  movingDate: string | null;
  emailAddress: string | null;
  homePhoneNumber: string | null;
  homePhoneExtension: string | null;
  homePhoneNotificationType: NotificationType | null;
  cellPhoneNumber: string | null;
  cellPhoneNotificationType: NotificationType | null;
};

/** type de notification possibles pour l'abonnement aux messages  */
export enum NotificationType {
  Text = 'text',
  Vocal = 'vocal',
  TextAndVocal = 'textAndVocal',
  None = 'none',
}
